<script setup>
import logo from '../../../assets/logo.jpg';
import {useI18n} from 'vue-i18n';
import {ref} from 'vue';
import {setDomain} from '@/helper';

const {t} = useI18n();

function selectDomain(domain) {
  setDomain(domain);
  emitter.emit('domainOverlayClosed');
}
</script>

<template>
  <div class="app-popup">
    <div class="row h-100 overflow-auto justify-content-center align-items-center p-2" style="z-index: 1055">
      <div class="col-md-6">
        <div class="app-popup__title">
          {{ t('domainSelectOverlay.choose_domain') }}
        </div>
        <div class="app-popup__content">
          <div class="row text-center">
            <div class="col-12 mb-4">
              <p>{{ t('domainSelectOverlay.choose_domain_text') }}</p>
            </div>
            <div class="col-12 mb-2 d-flex justify-content-center">
              <button type="button" @click="selectDomain('CZ')" class="btn btn-primary btn--with-icon btn--domain-cz btn-domain-select text-center">
                <span class="btn-icon"></span>
                <span class="btn-content">In Equity CZ</span>
              </button>
            </div>
            <div class="col-12 mb-2 d-flex justify-content-center">
              <button type="button" @click="selectDomain('SK')" class="btn btn-primary btn--with-icon btn--domain-sk btn-domain-select text-center">
                <span class="btn-icon"></span>
                <span class="btn-content">In Equity SK</span>
              </button>
            </div>
<!--            <div class="col-12 mb-2 d-flex justify-content-center">
              <button type="button" @click="selectDomain('SK/CZ')" class="btn btn-primary btn&#45;&#45;with-icon btn&#45;&#45;domain-cz btn-domain-select text-center">
                <span class="btn-icon"></span>
                <span class="btn-content">In Equity SK/CZ</span>
              </button>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>


